import { render } from "./AssignSingleAgent.vue?vue&type=template&id=60725a92"
import script from "./AssignSingleAgent.vue?vue&type=script&lang=js"
export * from "./AssignSingleAgent.vue?vue&type=script&lang=js"

import "./AssignSingleAgent.vue?vue&type=style&index=0&id=60725a92&scoepd=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__